import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../../helpers/utility';

const initialState = {
  leads: {},
  error: null,
  loading: false,
};

const leadDataStart = (state, action) => {
  return updateObject(state, {loading: true});
};

const leadDataSuccess = (state, action) => {
  return updateObject(state, {
    leads: action.leads,
    loading: false,
    error: null,
  });
};

const leadDataUpdate = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
  });
};

const leadDataFail = (state, action) => {
  return updateObject(state, {error: action.error, loading: false});
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LEAD_DATA_START:
      return leadDataStart(state, action);
    case actionTypes.LEAD_DATA_SUCCESS:
      return leadDataSuccess(state, action);
    case actionTypes.LEAD_DATA_FAIL:
      return leadDataFail(state, action);
    case actionTypes.LEAD_DATA_UPDATE:
      return leadDataUpdate(state, action);
    default:
      return state;
  }
};

export default reducer;
